/**
 * 🟥 CUADRO NEGRO DEFINITIVO 2026-06-27 — Mensajes de éxito bilingües.
 *
 * Diccionario centralizado de notificaciones verdes ("success toasts") de
 * DamyxIA. Cada clave devuelve un objeto { es, en } con el texto
 * correspondiente. Usado por `showSuccess(key)` en `showSuccess.js`.
 *
 * Reglas de extensión:
 *  - Añadir nuevas claves SIEMPRE con ambos idiomas (es/en).
 *  - Mantener mensajes cortos (<60 caracteres) — son toasts, no diálogos.
 *  - No incluir markdown ni HTML — son strings puros.
 */
export const successMessages = {
  image_sent: {
    es: 'Imagen enviada al Área de Trabajo',
    en: 'Image sent to Workspace',
  },
  image_already_sent: {
    es: 'La imagen ya estaba en el Área de Trabajo',
    en: 'Image already in Workspace',
  },
  component_added: {
    es: 'Componente agregado correctamente',
    en: 'Component added successfully',
  },
  project_saved: {
    es: 'Proyecto guardado',
    en: 'Project saved',
  },
  workspace_updated: {
    es: 'Área de Trabajo actualizada',
    en: 'Workspace updated',
  },
  action_completed: {
    es: 'Acción completada',
    en: 'Action completed',
  },
  file_uploaded: {
    es: 'Archivo cargado',
    en: 'File uploaded',
  },
  visual_created: {
    es: 'Elemento visual creado',
    en: 'Visual element created',
  },
  copied: {
    es: 'Copiado',
    en: 'Copied',
  },
  saved: {
    es: 'Guardado',
    en: 'Saved',
  },
};

export default successMessages;
